import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './remove_site.component.html'
})
export class RemoveSiteModalComponent extends BaseSupportModalComponent {
	title: string;
	siteId: string;
	userEmail: string;
	domainUrl: string;
	message: string;

	ngOnInit() {
		this.message = `Ваш сайт ${this.domainUrl} содержит запрещенный контент.`;
	}

	async ok() {
		if (confirm(`Вы уверены, что хотите удалить сайт ${this.domainUrl}?`)) {
			await this.supportService.setSiteBan(this.siteId, this.message, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
